import { createSlice } from "@reduxjs/toolkit";
import { getAllTimesheets, getTimesheetReport } from "../action/timesheetAction";

const initialState = {
  allTimesheets: [],
  timesheetReport: [],
  timesheetReportLoading: false,
};

export const timesheetSlice = createSlice({
  name: "timesheet",
  initialState,
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(getAllTimesheets.fulfilled, (state, action) => {
      state.allTimesheets = action.payload;
    });
    builder
      .addCase(getTimesheetReport.pending, (state) => {
        state.timesheetReportLoading = true;
      })
      .addCase(getTimesheetReport.fulfilled, (state, action) => {
        state.timesheetReportLoading = false;
        state.timesheetReport = action.payload ?? [];
      })
      .addCase(getTimesheetReport.rejected, (state) => {
        state.timesheetReportLoading = false;
        state.timesheetReport = [];
      });
  },
});

export default timesheetSlice.reducer;
